if (!customElements.get('skeleton-loader')) {
    class SkeletonLoader extends HTMLElement {
        constructor() {
            super();
            this.childElement = this.dataset.childElement;
        }
        /*
        connectedCallback() {
            console.log('this,', this);
            if(this.querySelector('content-scheduling')) {

                if (this.querySelector('content-scheduling').style.display=="block") {

                    this.parentElement.querySelector('.skeleton-loader-banner').style.display = 'none';
                    this.style.display = 'block';
                }
            }
        }
            */
        connectedCallback() {
            this.parentElement.querySelector('.skeleton-loader-banner').style.display = 'none';
            this.style.display = 'block';
        }
    }

    customElements.define('skeleton-loader', SkeletonLoader);
}
